import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { PoliciesComponent } from '../policies/policies.component';
import { IntroComponent } from '../intro/intro.component';
import { MoreInfoComponent } from '../more-info/more-info.component';

@Component({
  selector: 'flex-privacy-policy-home',
  imports: [HeaderComponent, PoliciesComponent, IntroComponent, MoreInfoComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent {}
